/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_SaveInputs */

const en_directory_promotion_save = /** @type {(inputs: Directory_Promotion_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save promotion preview`)
};

const zh_directory_promotion_save = /** @type {(inputs: Directory_Promotion_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存推广预览`)
};

/**
* | output |
* | --- |
* | "Save promotion preview" |
*
* @param {Directory_Promotion_SaveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_save = /** @type {((inputs?: Directory_Promotion_SaveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_SaveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_save(inputs)
	return zh_directory_promotion_save(inputs)
});
export { directory_promotion_save as "directory.promotion.save" }